<template>
    <div class="usage-list">
        <h6 class="text-xs text-gray-500 font-semibold uppercase tracking-wider mb-2">Gebruik</h6>

        <div v-if="usages.length > 0">
            <a
                v-for="(usage, index) in usages"
                :key="index"
                :href="usage.url"
                class="flex items-center gap-2 px-3 py-2 -mx-3 rounded hover:bg-gray-50 text-sm text-gray-700 no-underline"
                target="_blank"
            >
                <i :class="getUsageIcon(usage.type)" class="text-gray-400"></i>
                <span class="flex-1 min-w-0">
                    <span class="block truncate">{{ usage.label }}</span>
                    <span v-if="usage.sublabel" class="block truncate text-xs text-gray-400">{{ usage.sublabel }}</span>
                </span>
                <i class="far fa-external-link text-xs text-gray-300"></i>
            </a>
        </div>

        <div v-else class="flex items-center gap-2 text-sm">
            <span class="badge badge-warning">
                <i class="far fa-exclamation-triangle mr-1"></i>
                Niet in gebruik
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MediaUsageList',

    props: {
        usages: { type: Array, default: function () { return []; } },
        usageCount: { type: Number, default: 0 },
    },

    methods: {
        getUsageIcon(type) {
            var icons = {
                page: 'far fa-file-alt',
                model: 'far fa-database',
            };
            return icons[type] || 'far fa-link';
        },
    },
};
</script>
